import baseAPI from '@/api/base';
import {
  EditFolder,
  GetFolder,
  RegisterFolder,
} from '@/dtos/folder.dto';
import {
  DELETE_FOLDER_URL,
  EDIT_FOLDER_URL,
  GET_FOLDER_URL,
  REGISTER_FOLDER_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class Folder {
  static getFolders = async (
    getFolder: GetFolder
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_FOLDER_URL, {
      params: getFolder,
    });
    return response;
  };

  static registerFolder = async (
    registerFolder: RegisterFolder
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(
      REGISTER_FOLDER_URL,
      {
        ...registerFolder,
      }
    );
    return response;
  };

  static editFolder = async (
    editFolder: EditFolder
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(
      EDIT_FOLDER_URL,
      {
        ...editFolder,
      }
    );
    return response;
  };

  static deleteFolder = async (
    id: string
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_FOLDER_URL}/${id}`
    );
    return response;
  };
}

export default Folder;
